/**
 * servicosHabilitados.js — leitura do doc `servicoshabilitados/{domainId}`.
 *
 * O doc decide, POR PORTAL (federação/entidade do useAuth), quais módulos do SIE estão
 * ligados (ex.: `servicos.crm.habilitado`, ver hooks/useModuloCrm.js). Esta função só LÊ;
 * quem interpreta cada chave é o consumidor.
 *
 * Veio de federation/moduloFederado.js quando a Module Federation saiu do SIE (23/10/2026),
 * com o mesmo comportamento: o useModuloCrm dependia dela e não pode mudar de semântica.
 */

/**
 * Lê `servicoshabilitados/{domainId}` FAIL-CLOSED: qualquer ausência/erro → null (o
 * consumidor trata null como "nada habilitado"). NB: GenericService.getOne LANÇA se o doc
 * não existir (mesmo com silentError), por isso o try/catch.
 * @param {string} domainId  domainDetails.domainId (federação/entidade do portal)
 * @param {(col:string,id:string,silent?:boolean)=>Promise<object|null>} getOne  injetável
 */
export async function carregarServicosDoc(domainId, getOne) {
  if (!domainId) return null;
  try {
    return await getOne('servicoshabilitados', domainId, true);
  } catch (_) {
    return null; // doc ausente/erro → fail-closed
  }
}
